<template>
	<section class="section applications">
		<div class="container mx-auto">

      <search-sort :modelValue="searchSortData" :sortMenu="sortMenu" placeholder="Search Applications"></search-sort>

			<div class="appliction__cards">
				<template v-if="!me">
					You must be signed in to see applications
				</template>
				<template v-else-if="!applications">
					Loading...
				</template>
				<template v-else-if="computedFliteredApplications.length == 0">
					No applications found
				</template>
				<template v-else>
					<template v-for="(result, a) in computedFliteredApplications" :key="`applications_${a}`">
            <block-job-card-slim :payload="result"></block-job-card-slim>
					</template>
				</template>
			</div>
		</div>
	</section>
</template>

<script>
import algoliasearch from 'algoliasearch';
import AuthMixins from '@/mixins/AuthMixins';
import SearchSort from './partials/SearchSort';

export default {
	mixins: [AuthMixins],

  components: {
  	SearchSort
	},

	props: {
		bubble_site_url: {
			type: String
		}
	},

	data() {
		return {
			applications: false,

			client: false,
			index: false,
			index_name: (this.$config.test_env) ? 'listings-test-latest' : 'listings-live-latest',
			searchObject: {
				hitsPerPage: 3,
				facets: ['objectID'],
				facetFilters: []
			},
      searchSortData: {search:'', sort:'title_asc'},
      sortMenu: [
        { title: 'Title Ascending', value: 'title_asc', selected: false },
        { title: 'Title Descending', value: 'title_desc', selected: false },
        { title: 'Newest First', value: 'date_desc', selected: false },
        { title: 'Oldest First', value: 'date_asc', selected: false }
      ]
		}
	},

	mounted() {
		if (this.me) {
      this.client = algoliasearch(this.$config.algolia.app_id, this.$config.algolia.app_key);
      this.index = this.client.initIndex(this.index_name);
		}
	},

	methods: {
		loadData() {
      // console.log('Applied Jobs:', this.computedJobsApplied);
      // Set hitsPerPage to length of this.computedPayload.slugs array.
      // Loop through this.computedPayload.slugs and prefixing them with 'slugs:', then add them to facetFilters.
      this.searchObject.hitsPerPage = this.computedJobsApplied.length;
      this.searchObject.facetFilters.push(this.computedJobsApplied.map(el => `objectID:${el['job-id']}`));

			this.index
				.search('', this.searchObject)
				.then((results) => {
					// console.log("Applied jobs search raw results:", results);
					//if (results.nbHits > 0) {
						this.applications = results.hits;
					//} else {
					//	this.applications = false;
					//}
				});
		},
		getNPS(result) {
      return result['av-nps'];
		},
		calcJobLink(result) {
			if (result['slug'] == undefined || result['slug'] == '') {
				return `/opportunity/redirect/${result['objectID']}`;
			}
			return `/opportunity/${result['slug']}`;
		},
    refreshFilters() {
      switch (this.searchSortData.sort) {
        case 'title_asc':
        this.applications.sort((a, b) => a['job-title'].toLowerCase().localeCompare(b['job-title'].toLowerCase()));
          break;
        case 'title_desc':
        this.applications.sort((a, b) => b['job-title'].toLowerCase().localeCompare(a['job-title'].toLowerCase()));
          break;
        case 'date_asc':
        this.applications.sort((a, b) => a['posted-date'] - b['posted-date']);
          break;
        case 'date_desc':
        this.applications.sort((a, b) => b['posted-date'] - a['posted-date']);
          break;
      }
    }
	},

	computed: {
    computedJobsApplied() {
      return this.me["applications"];
    },
    computedFliteredApplications() {
      return this.applications.filter(v => {
        return v['job-title'].toLowerCase().includes(this.searchSortData.search.toLowerCase());
      });
    }
  },

  watch: {
    computedJobsApplied(newVal, oldVal) {
			// console.log("Computed Jobs Applied changed", this.me);
      this.$nextTick(() => {
				this.loadData();
			})
    },
    searchSortData: {
      deep:true,
      handler() {
        this.refreshFilters();
      }
    }
  }
}
</script>
